import React, { useMemo } from 'react'
import { BtButton } from '@linqpal/components/src/ui'
import ProjectStore from '../Store'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import RootStore from '../../../store'
import { useNavigation, useRoute } from '@react-navigation/native'
import projectsStore from '../../Projects/Store'

export const NextButton: React.FC = observer(() => {
  const { t } = useTranslation('global')
  const { isBusy } = RootStore
  const route = useRoute()
  const navigation = useNavigation()
  const {
    setUpNextSection,
    isCurrentSectionFilled,
    isLastSection,
    allSectionsFilled,
    submit,
  } = ProjectStore
  const { resetRefresher } = projectsStore

  const reloadProjects = () => {
    resetRefresher()
  }
  const onPress = () => {
    if (isLastSection) {
      if (allSectionsFilled) {
        submit(
          navigation,
          reloadProjects,
          (route.params as any)?.ids,
          (route.params as any)?.projectId,
        )
      }
    } else {
      setUpNextSection()
    }
  }
  const isEdit = useMemo(() => {
    return isLastSection && (route.params as any)?.projectId
  }, [route.params, isLastSection])

  return (
    <BtButton
      onPress={onPress}
      style={{ minWidth: 132, borderRadius: 4 }}
      testID="ProjectNextButton"
      disabled={!isCurrentSectionFilled || isBusy}
    >
      {isEdit ? t('ProjectForm.update') : t('ProjectForm.next-button-label')}
    </BtButton>
  )
})
